import * as _ from 'lodash';

export const FIELD_CONFIG_PROPERTIES = [
  'field_label',
  'field_type',
  'semantics',
  'comparisons',
  'possible_values_population',
  'possible_values',
  'for_personalization',
  'for_encryption'
];

export default {
  deserialize(fieldConfigsObject={}){
    return _.reduce(_.keys(fieldConfigsObject), (result, field_name) => {
      result.push(_.merge({field_name}, fieldConfigsObject[field_name]));
      return result;
    }, []);
  },
  serialize(fieldConfigsArray=[]){
    return _.reduce(fieldConfigsArray, (result, fieldConfig) => {
      result[fieldConfig.field_name] = _.pick(fieldConfig, FIELD_CONFIG_PROPERTIES);
      return result;
    }, {});
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/fieldConfigsTransform.js
 **/